<template>
  <Modal>
    <Modal.Body>
      <div class="px-0 pt-0 mb-4">
        <h2
          class="text-left text-[28px] font-medium leading-[34px] text-gray-800 max-w-full"
        >
          Deactivate or delete account
        </h2>

        <div class="mt-[30px] flex flex-col gap-[30px]">
          <div class="flex gap-5">
            <EyeClosedIcon class="size-[26px] shrink-0 text-gray-800" />
            <div>
              <p class="text-[18px] font-medium leading-[24px] text-gray-800">
                Deactivation is temporary
              </p>
              <p class="mt-2 text-[14px] leading-[20px] text-gray-800">
                Your account is disabled and your plan cancelled. You can log
                back in anytime to reactivate.
              </p>
            </div>
          </div>

          <div class="flex gap-5">
            <AlertIcon class="size-[26px] shrink-0 text-gray-800" />
            <div>
              <p class="text-[18px] font-medium leading-[24px] text-gray-800">
                Deletion is permanent
              </p>
              <p class="mt-2 text-[14px] leading-[20px] text-gray-800">
                Your account is removed and cannot be restored. Your
                registrations remain on Dacr as evidentiary records.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Modal.Body>
    <Modal.Footer layout="vertical">
      <Button variant="danger" size="lg" @click="handleDeactivate">
        Deactivate account
      </Button>
      <Button variant="stroke" size="lg" @click="handleDelete"
        >Delete account</Button
      >
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { Modal, Button } from '@dacr/library'

import { openDialog, Dialog } from '@/shared/dialogs/dialog'
import { EyeClosedIcon, AlertIcon } from '@dacr/icons'

const handleDeactivate = () =>
  openDialog(Dialog.AccountClosureInfo, {
    props: { mode: 'deactivate' },
    stack: 'cover',
  })

const handleDelete = () =>
  openDialog(Dialog.AccountClosureInfo, {
    props: { mode: 'delete' },
    stack: 'cover',
  })
</script>
